import React from 'react'
import './quotes.css'

const excerpts = [
  {
    quote: 'A haunting and darkly beautiful tale of revenge.',
    attribute: 'horrornews.net'
  },
  {
    quote: 'A stylish haunting thriller...dark, original and chilling.',
    attribute: 'Richard Roeper, Chicago Sun-Times'
  },
  {
    quote: 'Ted Levine gives one of the most memorable performances of his career',
    attribute: 'Richard Roeper, Chicago Sun-Times'
  },
  {
    quote: 'An inky dose of the supernatural',
    attribute: 'New Orleans Film Society'
  },
  {
    quote: 'Part moody Stephen King-style thriller, part brooding family drama',
    attribute: 'Culture Crypt'
  },
  {
    quote: 'Decidedly unique',
    attribute: 'Gruesome Magazine'
  },
  {
    quote: 'Hunter Adams’ Dig Two Graves is that rare chiller conjuring eeriness and dread.',
    attribute: 'Andy Webster, The New York Times'
  },
  {
    quote: 'Creepy Thriller Dig Two Graves evokes the best of Stephen King',
    attribute: 'Noel Murray, Los Angeles Times'
  },
  {
    quote: 'Gripping horror-thriller, handsomely wrought',
    attribute: 'Jane Horwitz, Washington Post'
  },
  {
    quote: 'DIG TWO GRAVES will stick in your mind long after your memories of chart-toppers have long since faded',
    attribute: 'Peter Sobczynski, RogerEbert.com'
  },
  {
    quote: 'Dig Two Graves is handsomely accomplished in all departments',
    attribute: 'Dennis Harvey, Variety'
  },
  {
    quote: 'Dig Two Graves is a low-budget visual treat',
    attribute: 'Mike D’Angelo, The Onion A.V. Club'
  },
  {
    quote: 'Dig Two Graves is an amazing thriller of a film',
    attribute: 'Pat Torfe, Bloody Disgusting'
  }
]

function shuffle (arr) {
  var cur = arr.length, tmp, ran
  while (0 !== cur) {
    ran = Math.floor(Math.random() * cur)
    cur -= 1
    tmp = arr[cur]
    arr[cur] = arr[ran]
    arr[ran] = tmp
  }
  return arr
}

let quoteList = shuffle(excerpts)
  .map((el, i) => (
    <blockquote key={i} className="quote">“{el.quote}”
      <footer className="quote-source">{el.attribute}</footer>
    </blockquote>))

function Quotes () {
  let classes = location.pathname !== '/' ? 'quotes paused' : 'quotes'
  return (<div className={classes}>{quoteList}</div>)
}

export default Quotes



// WEBPACK FOOTER //
// ./src/components/quotes.js